import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeEntity: localStorage.getItem("OTC_V2_ACTIVE_ENTITY") || "",
  activeSidebarItem: localStorage.getItem("OTC_V2_ACTIVE_SIDEBAR_ITEM") || "",
};

const activeEntitySlice = createSlice({
  name: "activeEntity",
  initialState,
  reducers: {
    setActiveEntity(state, action) {
      state.activeEntity =
        typeof action.payload === "string" ? action.payload : "";
    },
    clearActiveEntity(state) {
      state.activeEntity = "";
    },
    setActiveSidebarItem(state, action) {
      state.activeSidebarItem =
        typeof action.payload === "string" ? action.payload : "";
    },
    clearActiveSidebarItem(state) {
      state.activeSidebarItem = "";
    },
  },
});

export const {
  setActiveEntity,
  clearActiveEntity,
  setActiveSidebarItem,
  clearActiveSidebarItem,
} = activeEntitySlice.actions;

export const selectActiveEntity = (state) =>
  (state.activeEntity && state.activeEntity.activeEntity) || "";

export const selectActiveSidebarItem = (state) =>
  (state.activeEntity && state.activeEntity.activeSidebarItem) || "";

export default activeEntitySlice.reducer;
